import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const helpData = {
  PasswordHelp: [
    {
      question: "How do I reset my Password?",
      answer: `To change your password:

• Click on ≡ (top left corner)

• Go to "Profile" section

• Click on “Edit Password” to update your password`,
    },
    {
      question: "What if I forgot my password?",
      answer: `To reset your password:

• On the Login page, enter your mobile number and click on “Forgot Password”

• An OTP will be sent to your registered mobile number

• Enter the OTP for verification

• If OTP matches, you’ll be allowed to set a new password`,
    },
  ],
};

const PasswordHelp = ({ selectedSection = "LoadMoney" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Password.jpg"
          alt="Profile illustration"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* FAQ Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Password Help
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default PasswordHelp;
